import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class ReportJobOrderService extends GenericService {
    constructor() {
        super('/reports/job_order', axiosInstance);
    }
}

export default new ReportJobOrderService(); 